import { UnsupportedChainIdError, useWeb3React } from '@web3-react/core';
import { useEffect, useState } from 'react';
import { SupportedConnectors } from '../../config/constants';
import useConnectionState from '../../context/connection/useConnectionState';
import { injected } from '../../web3/connectors';
import { config } from '../../config/config';
import { hexStripZeros } from 'ethers/lib/utils';
import { BigNumber } from 'ethers';
import { ExternalProvider } from '@ethersproject/providers';

const useAutoConnect = () => {
    const [tried, setTried] = useState(false);

    const { active, error, setError } = useWeb3React();
    const { activateWallet } = useConnectionState();

    useEffect(() => {
        if (!active && !error && !tried) {
            (async () => {
                const isAuthorized = await injected.isAuthorized();

                if (isAuthorized) {
                    // if user has already connected to MM but is on the wrong chain
                    const connectedChain = await injected.getChainId();
                    if (
                        !config.enabledChains.includes(
                            parseInt(connectedChain.toString())
                        )
                    ) {
                        // throwing error here otherwise it won't be catched due to activateWallet not executing
                        setError(
                            new UnsupportedChainIdError(
                                parseInt(connectedChain.toString()),
                                config.enabledChains
                            )
                        );

                        const provider: ExternalProvider = await injected.getProvider();

                        if (!provider.request) {
                            setTried(true);
                            return;
                        }

                        try {
                            await provider.request({
                                method: 'wallet_switchEthereumChain',
                                params: [
                                    {
                                        chainId: hexStripZeros(
                                            BigNumber.from(
                                                config.enabledChains[0]
                                            ).toHexString()
                                        ),
                                    },
                                ],
                            });
                        } catch (error: any) {
                            setTried(true);
                            return;
                        }
                    }

                    activateWallet(SupportedConnectors.METAMASK, injected);
                } else {
                    setTried(true);
                }
            })();
        }
    }, [active, tried, error, activateWallet, setError]);

    useEffect(() => {
        if (active) {
            setTried(true);
        }
    }, [active]);

    return tried;
};

export default useAutoConnect;
